export default __webpack_public_path__ + "e03eaf41982aeaac0c1a6609ee15695a.svg";